/**
 * 媒体查询 hook
 *
 * 返回当前视口是否匹配指定媒体查询表达式，
 * 用于 JS 侧的响应式分支（如侧栏移动端抽屉态），
 * 纯样式响应式仍优先用 Tailwind 断点前缀。
 */
import { useCallback, useSyncExternalStore } from 'react'

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(query)
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    },
    [query]
  )

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false
  )
}
